$('.Page_our_food_product_all_slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots:false,
  infinite: false,
  centerMode: false,
  prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="28.5" transform="rotate(-180 30 30)" fill="#0C3D37" stroke="white" stroke-width="3"/><path d="M35 40L25 30L35 20" stroke="white" stroke-width="3"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="28.5" fill="#0C3D37" stroke="white" stroke-width="3"/><path d="M25 20L35 30L25 40" stroke="white" stroke-width="3"/></svg></button>',
  responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 2,
      }
    }
  ]
});